module.exports = __webpack_public_path__ + "img/Group 1-3.4f2c1d9e.svg";